import React from 'react';
import TeacherClassroomsRouter from '../containers/TeacherClassroomsRouter';
import DemoAccountContextProvider from '../contexts/DemoAccountContextProvider';

export default ({ isDemo = false, ...props }) => (
  <DemoAccountContextProvider isDemo={isDemo}>
    <TeacherClassroomsRouter {...props} />
  </DemoAccountContextProvider>
);
